// 대량구매 설정 섹션 URL (2026-09-01 KST 추가)
const bulkPurchaseSettingsSection = "/bulk-purchase-settings";

export const bulkPurchaseSettingsPath = bulkPurchaseSettingsSection;
